<script>
    import { Doughnut } from 'vue-chartjs'

    export default {
        extends: Doughnut,
        props: ['chartdata', 'options','dataname','dncolor'],
        mounted () {
            Chart.defaults.global.legend.display = true;
            this.renderChart({
                labels: this.chartdata,
                datasets: [
                    {
                        label: this.dataname,
                        backgroundColor: this.dncolor,
                        data: this.options,
                    }
                ]
            }, { responsive: true, maintainAspectRatio: false })
        }
    }
</script>

<style scoped>



</style>
